export const MAX_CARDS_PER_USER = 5;

export const RESERVED_SLUGS = [
  'app', 'admin', 'login', 'register', 'signup', 'dashboard', 'profile', 
  'settings', 'pricing', 'features', 'support', 'help', 'api', 'auth', 
  'callback', 'reset-password', 'forgot-password', 'cards', 'leads', 
  'analytics', 'billing'
];